module.exports = __webpack_public_path__ + "img/booking-expired.74fd6caa.svg";